import React from 'react';
export function CeramicCoatingSection() {
  return <section id="ceramic" className="py-24 relative overflow-hidden" data-id="element-19">
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0D2B2B] to-[#111111] z-0" data-id="element-20"></div>

      {/* Decorative Glow */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#7FD4D4] opacity-5 rounded-full blur-3xl pointer-events-none" data-id="element-21"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-22">
        <span className="text-[#7FD4D4] font-bold tracking-[0.2em] text-sm uppercase block mb-4" data-id="element-23">
          Premium Protection
        </span>
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-white uppercase mb-6 max-w-4xl mx-auto leading-tight" data-id="element-24">
          Protect Your Investment with Ceramic Coating
        </h2>
        <p className="text-white/80 text-lg md:text-xl max-w-2xl mx-auto mb-10 font-light" data-id="element-25">
          Long-lasting protection against the harsh Phoenix sun, dust, and
          elements. Available as a standalone service or included in our
          Platinum package.
        </p>

        <a href="#booking" className="inline-block bg-[#7FD4D4] text-black text-lg font-bold px-10 py-5 rounded-sm uppercase tracking-wide hover:bg-[#6BC4C4] hover:scale-105 transition-all shadow-lg shadow-[#7FD4D4]/20" data-id="element-26">
          Learn About Ceramic Coating
        </a>
      </div>
    </section>;
}